const PrevIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.2373 21.4876C16.0123 21.4876 15.7873 21.4126 15.6373 21.2251L7.1623 12.6001C6.8248 12.2626 6.8248 11.7376 7.1623 11.4001L15.6373 2.7751C15.9748 2.4376 16.4998 2.4376 16.8373 2.7751C17.1748 3.1126 17.1748 3.6376 16.8373 3.9751L8.9623 12.0001L16.8748 20.0251C17.2123 20.3626 17.2123 20.8876 16.8748 21.2251C16.6498 21.3751 16.4623 21.4876 16.2373 21.4876Z'
        fill='#9CA3AF'
      />
    </svg>
  );
};

export default PrevIcon;
